import React from 'react';
import sIcon1 from '../../images/icon/eye-icon.svg'
import sIcon2 from '../../images/feature/ap-feature01.jpg'
import sIcon3 from '../../images/feature/ap-feature02.jpg'
import sIcon4 from '../../images/feature/ap-feature03.jpg'


const WhyChoose = (props) => {

    return (
        <section className="feature pt-130">
                <div className="container">
                    <div className="sec-title--two text-center mb-60">
                        <div className="sub-title"><img src={sIcon1} alt=""/> Why choose us</div>
                        <h2 className="title">Engineering That Moves Business Forward</h2>
                    </div>
                    <div className="row mt-none-30">
                        <div className="col-lg-4 col-md-6 mt-30">
                            <div className="ap-fea-item pos-rel">
                                <div className="xb-item--img"><img src={sIcon2} alt="AI and machine learning engineering"/></div>
                                <h3 className="xb-item--content">AI-driven solutions that turn data into real outcomes</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-30">
                            <div className="ap-fea-item pos-rel">
                                <div className="xb-item--img"><img src={sIcon3} alt="Cloud-native architecture and DevOps"/></div>
                                <h3 className="xb-item--content">Cloud-native architecture built to scale on demand</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-30">
                            <div className="ap-fea-item pos-rel">
                                <div className="xb-item--img"><img src={sIcon4} alt="Cybersecurity and data protection"/></div>
                                <h3 className="xb-item--content">Security-first delivery that protects every release</h3>
                            </div>
                        </div>
                    </div>
                </div>
             </section>
    );
}

export default WhyChoose;